import { render, staticRenderFns } from "./ClusterModal.vue?vue&type=template&id=64d8d8b8&scoped=true&"
import script from "./ClusterModal.vue?vue&type=script&lang=js&"
export * from "./ClusterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8d8b8",
  null
  
)

export default component.exports